import styled from 'styled-components';

export const ChargeOptionRow = styled.div`
    display: grid;
    grid-template-columns: minmax(0, 3fr) minmax(0, 6fr) minmax(0, 2fr) minmax(0, 3fr);
    align-items: center;
    column-gap: 16px;
    width: 100%;
`;

const truncate = `
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
`;

export const Code = styled.span`
    ${truncate}
`;

export const Desc = styled.span`
    color: rgba(0, 0, 0, 0.65);
    ${truncate}
`;

export const Nominal = styled.span`
    ${truncate}
`;

export const Tax = styled.span`
    color: rgba(0, 0, 0, 0.65);
    text-align: right;
    ${truncate}
`;

export const StylesChargeOptionsHeader = styled.div`
    display: grid;
    grid-template-columns: minmax(0, 3fr) minmax(0, 6fr) minmax(0, 2fr) minmax(0, 3fr);
    column-gap: 16px;
    padding: 4px 12px;
    border-bottom: 1px solid var(--neutral-4, #f0f0f0);
    font-size: 12px;
    color: rgba(0, 0, 0, 0.45);

    & > span:last-child {
        text-align: right;
    }
`;

export const SectionFormRow = styled.div`
    display: flex;
    justify-content: space-between;
    gap: 24px;
    align-items: center;
`;

export const SectionFormLabel = styled.label`
    white-space: nowrap;
    min-width: 120px;
`;

export const ControlWrapper = styled.div`
    flex: 1;
    max-width: 380px;
`;
